/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WindAssetUpdateCommand { 
    /**
     * A Date Time representation with zone information
     */
    Until?: string | null;
    TurbineManufacturer?: string;
    TurbineType?: string;
    NumberOfTurbines?: number;
    CutOutMs?: number;
    From?: string;
    ConnectionId?: number;
    Tenant?: string;
    Longitude?: number;
    Latitude?: number;
    PowerKwAc?: number;
    LimitKw?: number | null;
}

